module.exports = Clipboard;